import { getResourceFromObjectType } from '../actions';
import { getPreSignedUrlForDownload } from '../../../services/fileService';

export async function getFullscreenImageUrl(attachment) {
  const { objectType, objectId, fileId, fileName } = attachment;
  const resource = getResourceFromObjectType(objectType, false);
  const preSignedUrlObj = { resource, objectId, fileName };
  let url = null;
  try {
    const urls = await getPreSignedUrlForDownload(preSignedUrlObj);
    url = urls.url;
  } catch (e) {
    // some error, will return null
  }
  return url;
}
